import React, { useState, useEffect } from 'react';
import { useVoice } from '../context/VoiceContext';
import './MicrophonePermissionModal.css';

function MicrophonePermissionModal() {
  const { microphoneGranted, microphoneSupported, requestPermission } = useVoice();
  const [showModal, setShowModal] = useState(false);
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    // Check if permission has already been asked
    const permissionAsked = localStorage.getItem('voice_permission_asked');

    // Show modal only if:
    // 1. Browser supports microphone
    // 2. Permission hasn't been asked yet
    if (microphoneSupported && !permissionAsked) {
      setShowModal(true);
    }

    // Show warning if permission was denied
    if (!microphoneGranted && permissionAsked) {
      setShowWarning(true);
    }
  }, [microphoneSupported, microphoneGranted]);

  const handleEnableVoice = async () => {
    await requestPermission();
    setShowModal(false);

    // Check if permission was granted
    const permissionAsked = localStorage.getItem('voice_permission_asked');
    if (!microphoneGranted && permissionAsked) {
      setShowWarning(true);
    }
  };

  const handleSkipForNow = () => {
    localStorage.setItem('voice_permission_asked', 'true');
    setShowModal(false);
    setShowWarning(true);
  };

  const handleDismissWarning = () => {
    setShowWarning(false);
  };

  if (!showModal && !showWarning) {
    return null;
  }

  if (showModal) {
    return (
      <div className="microphone-modal-overlay">
        <div className="microphone-modal">
          <div className="microphone-modal-header">
            <h2>Enable Voice Input?</h2>
            <p>
              Speak words aloud in games to practice pronunciation. This requires microphone permission.
            </p>
          </div>

          <div className="microphone-modal-buttons">
            <button
              className="microphone-btn enable"
              onClick={handleEnableVoice}
            >
              Enable Voice
            </button>
            <button
              className="microphone-btn skip"
              onClick={handleSkipForNow}
            >
              Skip for Now
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (showWarning) {
    return (
      <div className="microphone-warning">
        <div className="microphone-warning-content">
          <p>
            <strong>Microphone permission not available.</strong> You can still play all games,
            but voice input won't work. You can enable it anytime in your browser settings.
          </p>
          <button
            className="microphone-btn dismiss"
            onClick={handleDismissWarning}
          >
            Got it
          </button>
        </div>
      </div>
    );
  }

  return null;
}

export default MicrophonePermissionModal;
